import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderPaymentMethodModel } from '../models/order-payment-method.model';

export class OrderPaymentMethodsApiService extends ApiService {
  static endpoint = 'orders/{order_id}/payment-methods';

  /**
   * @param {String|Number} orderId
   * @param {Number|null} paymentMethodId
   * @return {String}
   * @protected
   */
  static buildOrderPaymentMethodUrl(orderId, paymentMethodId = null) {
    return this.buildUrl(paymentMethodId).replace('{order_id}', orderId);
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} paymentMethodId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderPaymentMethodModel>>}
   * @public
   */
  static async get(orderId, paymentMethodId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderPaymentMethodUrl(orderId, paymentMethodId), {
      ...config,
      dataModel: OrderPaymentMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderPaymentMethodModel>>}
   * @public
   */
  static getAll(orderId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderPaymentMethodUrl(orderId), {
      ...config,
      dataModel: OrderPaymentMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} paymentMethodId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderPaymentMethodModel>>}
   * @public
   */
  static async patch(orderId, paymentMethodId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildOrderPaymentMethodUrl(orderId, paymentMethodId), data, {
      ...config,
      dataModel: OrderPaymentMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
